<script setup lang="ts">
import type { HomeData } from '~/composables/useHomepage'

defineProps<{ data?: HomeData }>()
</script>

<template>
  <UContainer class="py-legacy-xl">
    <HomeProductCards
      v-if="data?.productCards?.length"
      :products="data?.productCards"
      class="mb-legacy-l"
    />
    <PacketRelatedCta
      text="Se alle våre bøker og digitale læremidler"
      link-label="Gå til produktkatalogen"
      :link-to="{ name: 'products' }"
    />
  </UContainer>
</template>
